import FlatList from "./FlatList";
import Banner from "./Banner";
import React from "react";

const Home = () => {
  return (
    <React.Fragment>
      <Banner />
      <FlatList />
    </React.Fragment>
  );
};

export default Home;
